import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useEffect, useState } from 'react'
import campaignApi from 'services/api/campaign'

import styles from './EmailSnapshot.module.scss'

const EmailSnapshot = ({ campaignId, onClose }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)
  const [html, setHtml] = useState('')
  const [subject, setSubject] = useState('')

  useEffect(() => {
    let cancelled = false

    campaignApi
      .getCampaignEmail({ campaignId })
      .then(emailData => {
        if (cancelled) return

        if (!emailData) {
          setIsErred(true)
          return
        }

        setHtml(emailData.html || '')
        setSubject(emailData.emailParams?.subject || '')
      })
      .catch(err => {
        console.warn(err)
        if (!cancelled) setIsErred(true)
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [campaignId])

  return (
    <ConfirmationDialog
      title="Email snapshot"
      maxWidth={720}
      contentPadding={0}
      onClose={onClose}
      hasConfirmButton={false}
    >
      <div className={styles.snapshotWrapper}>
        {isLoading && <LoadingIndicator inline />}
        {!isLoading && isErred && (
          <p className={styles.snapshotError}>
            Could not load the email template for this campaign.
          </p>
        )}
        {!isLoading && !isErred && (
          <>
            {subject && (
              <div className={styles.subjectRow}>
                <span className={styles.subjectLabel}>Subject</span>
                <span className={styles.subjectValue}>{subject}</span>
              </div>
            )}
            <iframe
              className={styles.snapshotFrame}
              title="Campaign email snapshot"
              sandbox=""
              srcDoc={
                html ||
                '<p style="font-family:sans-serif;padding:20px">No email content available.</p>'
              }
            />
          </>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default EmailSnapshot
